import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";
import FocusTrap from "../utils/FocusTrap";

export default class HeaderNavs {
	constructor() {
		this.header = document.querySelector(".header-main");

		if (this.header) {
			this.overlay = this.header.querySelector(".overlay");
			this.navBg = this.header.querySelector(".nav-main-bg");

			const mobileNavContainer = this.header.querySelector("#header-main-navs");
			this.focusTrap = mobileNavContainer ? new FocusTrap(mobileNavContainer) : null;

			this.toggleMobileNav();
			this.initMegaMenu();

			// Initialisation : masquer le menu au clavier et aux AT s'il démarre fermé sur mobile
			this.updateMobileNavInert();

			document.addEventListener("escape.pressed", () => {
				this.closeAllLev2();
			});

			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	toggleMobileNav() {
		this.navToggle = this.header.querySelector(".nav-toggle");
		if (this.navToggle) {
			this.navToggle.addEventListener("click", () => {
				if (document.body.classList.contains("navs-open")) {
					this.closeMobileNav();
				} else {
					this.openMobileNav();
				}
			});
		}
	}

	openMobileNav() {
		if (this.mobilePanel) this.mobilePanel.inert = false;
		document.body.classList.add("navs-open");
		this.navToggle?.setAttribute("aria-expanded", "true");
		this.navToggle?.setAttribute("aria-label", this.navToggle.dataset.labelClose);
		this.focusTrap?.activate(this.navToggle);

		GlobalVariables.lenis?.stop();
	}

	closeMobileNav() {
		document.body.classList.remove("navs-open");
		this.navToggle?.setAttribute("aria-expanded", "false");
		this.navToggle?.setAttribute("aria-label", this.navToggle.dataset.labelOpen);
		this.focusTrap?.deactivate();

		const activeMenuItems = this.header.querySelectorAll(".menu-item-lev1.active");
		activeMenuItems.forEach(item => {
			item.classList.remove("active");
			const subnav = item.querySelector(".lev2");
			if (subnav) {
				subnav.classList.remove("show");
			}
		});

		GlobalVariables.lenis?.start();
		this.updateMobileNavInert();
	}

	// Gère inert sur le panneau mobile (.navs) selon le contexte mobile/desktop.
	// Sur mobile, quand le menu est fermé, inert neutralise le panneau entier :
	// - retire les éléments du tab order et de l'arbre AT
	// - empêche le div.navs lui-même de recevoir le focus (overflow:scroll le rend
	//   focusable nativement dans les navigateurs Chromium quand il a du contenu défilable)
	// Sur desktop, inert est retiré car le panneau est visible et intégré au flux.
	updateMobileNavInert() {
		if (!this.mobilePanel) return;
		const isMobile = window.innerWidth <= GlobalVariables.header.getBreakpoint();
		this.mobilePanel.inert = isMobile;
	}

	initMegaMenu() {
		// Un clic sur l'overlay ferme tout
		this.overlay.addEventListener("click", () => {
			this.closeAllLev2();
		});

		this.mobilePanel = this.header.querySelector(".navs");
		this.navMain = this.header.querySelector(".nav-main");
		this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

		this.levelOneItems.forEach(levelOne => {
			levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
			levelOne.levelTwo = levelOne.querySelector(".lev2-items");

			if (!levelOne.levelTwo) {
				return;
			}

			// Sous-menu fermé par défaut : inert le retire du tab order et de l'arbre AT
			// immédiatement, sans attendre la fin de la transition visibility
			levelOne.levelTwo.inert = true;

			levelOne.toggle.addEventListener("click", (e) => {
				e.preventDefault();

				if (levelOne.classList.contains("active")) {
					this.header.classList.remove("subnav-active");
					this.adjustNavBgHeight(levelOne.levelTwo);
					levelOne.classList.remove("active");
					levelOne.levelTwo.classList.remove("show");
					levelOne.levelTwo.inert = true;
					levelOne.toggle.setAttribute("aria-expanded", false);

					if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
						GlobalVariables.lenis?.start();
					}
				} else {
					this.closeAllLev2();

					this.header.classList.add("subnav-active");
					this.adjustNavBgHeight(levelOne.levelTwo);
					levelOne.classList.add("active");
					levelOne.levelTwo.inert = false;
					levelOne.levelTwo.classList.add("show");
					levelOne.toggle.setAttribute("aria-expanded", true);

					if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
						GlobalVariables.lenis?.stop();
					}
				}
			});
		});
	}

	closeAllLev2() {
		this.header.classList.remove("subnav-active");
		this.levelOneItems.forEach(item => {
			item.classList.remove("active");
			item.levelTwo.classList.remove("show");
			item.levelTwo.inert = true;
			item.querySelector("button[data-header='toggler']").setAttribute("aria-expanded", "false");
		});

		if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
			GlobalVariables.lenis?.start();
		}
	}

	restoreNav() {
		this.closeAllLev2();
		this.closeMobileNav();
	}

	adjustNavBgHeight(levelTwo) {
		if (this.navBg && window.innerWidth > GlobalVariables.header.getBreakpoint()) {
			if (GlobalVariables.reducedMotion) {
				gsap.set(this.navBg, { height: levelTwo.offsetHeight });
			} else {
				gsap.to(this.navBg, { duration: 0.3, height: levelTwo.offsetHeight });
			}
		}
	}

	resize() {
		this.restoreNav();
	}
}
